
define('core/string_util',["require", "exports"], function(require, exports) {
    

    function FindUtil(encoding) {
        encoding = (function () {
            switch (typeof encoding) {
                case 'object':
                    return "" + encoding;
                case 'string':
                    return encoding;
                default:
                    throw new Error('Invalid encoding argument specified');
            }
        })();
        encoding = encoding.toLowerCase();

        switch (encoding) {
            case 'utf8':
            case 'utf-8':
                return UTF8;
            case 'ascii':
                return ASCII;
            case 'binary':
                return BINARY;
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return UCS2;
            case 'hex':
                return HEX;
            case 'base64':
                return BASE64;

            case 'binary_string':
                return BINSTR;
            case 'binary_string_ie':
                return BINSTRIE;
            case 'extended_ascii':
                return ExtendedASCII;

            default:
                throw new Error("Unknown encoding: " + encoding);
        }
    }
    exports.FindUtil = FindUtil;

    var UTF8 = (function () {
        function UTF8() {
        }
        UTF8.str2byte = function (str, buf) {
            var length = buf.length;
            var i = 0;
            var j = 0;
            var maxJ = length;
            var rv = [];
            var numChars = 0;
            while (i < str.length && j < maxJ) {
                var code = str.charCodeAt(i++);
                var next = str.charCodeAt(i);
                if (0xD800 <= code && code <= 0xDBFF && 0xDC00 <= next && next <= 0xDFFF) {
                    if (j + 3 >= maxJ) {
                        break;
                    } else {
                        numChars++;
                    }

                    var codePoint = (((code & 0x3FF) | 0x400) << 10) | (next & 0x3FF);

                    buf.writeUInt8((codePoint >> 18) | 0xF0, j++);

                    buf.writeUInt8(((codePoint >> 12) & 0x3F) | 0x80, j++);
                    buf.writeUInt8(((codePoint >> 6) & 0x3F) | 0x80, j++);
                    buf.writeUInt8((codePoint & 0x3F) | 0x80, j++);
                    i++;
                } else if (code < 0x80) {
                    buf.writeUInt8(code, j++);
                    numChars++;
                } else if (code < 0x800) {
                    if (j + 1 >= maxJ) {
                        break;
                    } else {
                        numChars++;
                    }

                    buf.writeUInt8((code >> 6) | 0xC0, j++);

                    buf.writeUInt8((code & 0x3F) | 0x80, j++);
                } else if (code < 0x10000) {
                    if (j + 2 >= maxJ) {
                        break;
                    } else {
                        numChars++;
                    }

                    buf.writeUInt8((code >> 12) | 0xE0, j++);

                    buf.writeUInt8(((code >> 6) & 0x3F) | 0x80, j++);

                    buf.writeUInt8((code & 0x3F) | 0x80, j++);
                }
            }
            return j;
        };

        UTF8.byte2str = function (buff) {
            var chars = [];
            var i = 0;
            while (i < buff.length) {
                var code = buff.readUInt8(i++);
                if (code < 0x80) {
                    chars.push(String.fromCharCode(code));
                } else if (code < 0xC0) {
                    throw new Error('Found incomplete part of character in string.');
                } else if (code < 0xE0) {
                    chars.push(String.fromCharCode(((code & 0x1F) << 6) | (buff.readUInt8(i++) & 0x3F)));
                } else if (code < 0xF0) {
                    chars.push(String.fromCharCode(((code & 0xF) << 12) | ((buff.readUInt8(i++) & 0x3F) << 6) | (buff.readUInt8(i++) & 0x3F)));
                } else if (code < 0xF8) {
                    var byte3 = buff.readUInt8(i + 2);
                    chars.push(String.fromCharCode(((((code & 0x7) << 8) | ((buff.readUInt8(i++) & 0x3F) << 2) | ((buff.readUInt8(i++) & 0x3F) >> 4)) & 0x3FF) | 0xD800));

                    chars.push(String.fromCharCode((((byte3 & 0xF) << 6) | (buff.readUInt8(i++) & 0x3F)) | 0xDC00));
                } else {
                    throw new Error('Unable to represent UTF-8 string as UTF-16 JavaScript string.');
                }
            }
            return chars.join('');
        };

        UTF8.byteLength = function (str) {
            var m = encodeURIComponent(str).match(/%[89ABab]/g);
            return str.length + (m ? m.length : 0);
        };
        return UTF8;
    })();
    exports.UTF8 = UTF8;

    var ASCII = (function () {
        function ASCII() {
        }
        ASCII.str2byte = function (str, buf) {
            var length = str.length > buf.length ? buf.length : str.length;
            for (var i = 0; i < length; i++) {
                buf.writeUInt8(str.charCodeAt(i) % 256, i);
            }
            return length;
        };

        ASCII.byte2str = function (buff) {
            var chars = new Array(buff.length);
            for (var i = 0; i < buff.length; i++) {
                chars[i] = String.fromCharCode(buff.readUInt8(i) & 0x7F);
            }
            return chars.join('');
        };

        ASCII.byteLength = function (str) {
            return str.length;
        };
        return ASCII;
    })();
    exports.ASCII = ASCII;

    var ExtendedASCII = (function () {
        function ExtendedASCII() {
        }
        ExtendedASCII.str2byte = function (str, buf) {
            var length = str.length > buf.length ? buf.length : str.length;
            for (var i = 0; i < length; i++) {
                var charCode = str.charCodeAt(i);
                if (charCode > 0x7F) {
                    var charIdx = ExtendedASCII.extendedChars.indexOf(str.charAt(i));
                    if (charIdx > -1) {
                        charCode = charIdx + 0x80;
                    }
                }
                buf.writeUInt8(charCode, i);
            }
            return length;
        };

        ExtendedASCII.byte2str = function (buff) {
            var chars = new Array(buff.length);
            for (var i = 0; i < buff.length; i++) {
                var charCode = buff.readUInt8(i);
                if (charCode > 0x7F) {
                    chars[i] = ExtendedASCII.extendedChars[charCode - 128];
                } else {
                    chars[i] = String.fromCharCode(charCode);
                }
            }
            return chars.join('');
        };

        ExtendedASCII.byteLength = function (str) {
            return str.length;
        };
        ExtendedASCII.extendedChars = [
            '\u00C7', '\u00FC', '\u00E9', '\u00E2', '\u00E4',
            '\u00E0', '\u00E5', '\u00E7', '\u00EA', '\u00EB', '\u00E8', '\u00EF',
            '\u00EE', '\u00EC', '\u00C4', '\u00C5', '\u00C9', '\u00E6', '\u00C6',
            '\u00F4', '\u00F6', '\u00F2', '\u00FB', '\u00F9', '\u00FF', '\u00D6',
            '\u00DC', '\u00F8', '\u00A3', '\u00D8', '\u00D7', '\u0192', '\u00E1',
            '\u00ED', '\u00F3', '\u00FA', '\u00F1', '\u00D1', '\u00AA', '\u00BA',
            '\u00BF', '\u00AE', '\u00AC', '\u00BD', '\u00BC', '\u00A1', '\u00AB',
            '\u00BB', '_', '_', '_', '\u00A6', '\u00A6', '\u00C1', '\u00C2', '\u00C0',
            '\u00A9', '\u00A6', '\u00A6', '+', '+', '\u00A2', '\u00A5', '+', '+', '-',
            '-', '+', '-', '+', '\u00E3', '\u00C3', '+', '+', '-', '-', '\u00A6', '-',
            '+', '\u00A4', '\u00F0', '\u00D0', '\u00CA', '\u00CB', '\u00C8', 'i',
            '\u00CD', '\u00CE', '\u00CF', '+', '+', '_', '_', '\u00A6', '\u00CC', '_',
            '\u00D3', '\u00DF', '\u00D4', '\u00D2', '\u00F5', '\u00D5', '\u00B5',
            '\u00FE', '\u00DE', '\u00DA', '\u00DB', '\u00D9', '\u00FD', '\u00DD',
            '\u00AF', '\u00B4', '\u00AD', '\u00B1', '_', '\u00BE', '\u00B6', '\u00A7',
            '\u00F7', '\u00B8', '\u00B0', '\u00A8', '\u00B7', '\u00B9', '\u00B3',
            '\u00B2', '_', ' '];
        return ExtendedASCII;
    })();
    exports.ExtendedASCII = ExtendedASCII;

    var BINARY = (function () {
        function BINARY() {
        }
        BINARY.str2byte = function (str, buf) {
            var length = str.length > buf.length ? buf.length : str.length;
            for (var i = 0; i < length; i++) {
                buf.writeUInt8(str.charCodeAt(i) & 0xFF, i);
            }
            return length;
        };

        BINARY.byte2str = function (buff) {
            var chars = new Array(buff.length);
            for (var i = 0; i < buff.length; i++) {
                chars[i] = String.fromCharCode(buff.readUInt8(i) & 0xFF);
            }
            return chars.join('');
        };

        BINARY.byteLength = function (str) {
            return str.length;
        };
        return BINARY;
    })();
    exports.BINARY = BINARY;

    var BASE64 = (function () {
        function BASE64() {
        }
        BASE64.byte2str = function (buff) {
            var output = '';
            var i = 0;
            while (i < buff.length) {
                var chr1 = buff.readUInt8(i++);
                var chr2 = i < buff.length ? buff.readUInt8(i++) : NaN;
                var chr3 = i < buff.length ? buff.readUInt8(i++) : NaN;
                var enc1 = chr1 >> 2;
                var enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                var enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                var enc4 = chr3 & 63;
                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }
                output = output + BASE64.num2b64[enc1] + BASE64.num2b64[enc2] + BASE64.num2b64[enc3] + BASE64.num2b64[enc4];
            }
            return output;
        };

        BASE64.str2byte = function (str, buf) {
            var length = buf.length;
            var output = '';
            var i = 0;
            str = str.replace(/[^A-Za-z0-9\+\/\=\-\_]/g, '');
            var j = 0;
            while (i < str.length) {
                var enc1 = BASE64.b642num[str.charAt(i++)];
                var enc2 = BASE64.b642num[str.charAt(i++)];
                var enc3 = BASE64.b642num[str.charAt(i++)];
                var enc4 = BASE64.b642num[str.charAt(i++)];
                var chr1 = (enc1 << 2) | (enc2 >> 4);
                var chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                var chr3 = ((enc3 & 3) << 6) | enc4;
                buf.writeUInt8(chr1, j++);
                if (j === length) {
                    break;
                }
                if (enc3 !== 64) {
                    output += buf.writeUInt8(chr2, j++);
                }
                if (j === length) {
                    break;
                }
                if (enc4 !== 64) {
                    output += buf.writeUInt8(chr3, j++);
                }
                if (j === length) {
                    break;
                }
            }
            return j;
        };

        BASE64.byteLength = function (str) {
            return Math.floor(((str.replace(/[^A-Za-z0-9\+\/\-\_]/g, '')).length * 6) / 8);
        };
        BASE64.b64chars = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '+', '/', '='];
        BASE64.num2b64 = (function () {
            var obj = new Array(BASE64.b64chars.length);
            for (var idx = 0; idx < BASE64.b64chars.length; idx++) {
                var i = BASE64.b64chars[idx];
                obj[idx] = i;
            }
            return obj;
        })();

        BASE64.b642num = (function () {
            var obj = {};
            for (var idx = 0; idx < BASE64.b64chars.length; idx++) {
                var i = BASE64.b64chars[idx];
                obj[i] = idx;
            }
            obj['-'] = 62;
            obj['_'] = 63;
            return obj;
        })();
        return BASE64;
    })();
    exports.BASE64 = BASE64;

    var UCS2 = (function () {
        function UCS2() {
        }
        UCS2.str2byte = function (str, buf) {
            var len = str.length;

            if (len * 2 > buf.length) {
                len = buf.length % 2 === 1 ? (buf.length - 1) / 2 : buf.length / 2;
            }
            for (var i = 0; i < len; i++) {
                buf.writeUInt16LE(str.charCodeAt(i), i * 2);
            }
            return len * 2;
        };

        UCS2.byte2str = function (buff) {
            if (buff.length % 2 !== 0) {
                throw new Error('Invalid UCS2 byte array.');
            }
            var chars = new Array(buff.length / 2);
            for (var i = 0; i < buff.length; i += 2) {
                chars[i / 2] = String.fromCharCode(buff.readUInt8(i) | (buff.readUInt8(i + 1) << 8));
            }
            return chars.join('');
        };

        UCS2.byteLength = function (str) {
            return str.length * 2;
        };
        return UCS2;
    })();
    exports.UCS2 = UCS2;

    var HEX = (function () {
        function HEX() {
        }
        HEX.str2byte = function (str, buf) {
            if (str.length % 2 === 1) {
                throw new Error('Invalid hex string');
            }

            var numBytes = str.length >> 1;
            if (numBytes > buf.length) {
                numBytes = buf.length;
            }
            for (var i = 0; i < numBytes; i++) {
                var char1 = this.hex2num[str.charAt(i << 1)];
                var char2 = this.hex2num[str.charAt((i << 1) + 1)];
                buf.writeUInt8((char1 << 4) | char2, i);
            }
            return numBytes;
        };

        HEX.byte2str = function (buff) {
            var len = buff.length;
            var chars = new Array(len << 1);
            var j = 0;
            for (var i = 0; i < len; i++) {
                var hex2 = buff.readUInt8(i) & 0xF;
                var hex1 = buff.readUInt8(i) >> 4;
                chars[j++] = this.num2hex[hex1];
                chars[j++] = this.num2hex[hex2];
            }
            return chars.join('');
        };

        HEX.byteLength = function (str) {
            return str.length >> 1;
        };
        HEX.HEXCHARS = '0123456789abcdef';

        HEX.num2hex = (function () {
            var obj = new Array(HEX.HEXCHARS.length);
            for (var idx = 0; idx < HEX.HEXCHARS.length; idx++) {
                var i = HEX.HEXCHARS[idx];
                obj[idx] = i;
            }
            return obj;
        })();

        HEX.hex2num = (function () {
            var idx, i;
            var obj = {};
            for (idx = 0; idx < HEX.HEXCHARS.length; idx++) {
                i = HEX.HEXCHARS[idx];
                obj[i] = idx;
            }
            var capitals = 'ABCDEF';
            for (idx = 0; idx < capitals.length; idx++) {
                i = capitals[idx];
                obj[i] = idx + 10;
            }
            return obj;
        })();
        return HEX;
    })();
    exports.HEX = HEX;

    var BINSTR = (function () {
        function BINSTR() {
        }
        BINSTR.str2byte = function (str, buf) {
            if (str.length === 0) {
                return 0;
            }
            var numBytes = BINSTR.byteLength(str);
            if (numBytes > buf.length) {
                numBytes = buf.length;
            }
            var j = 0;
            var startByte = 0;
            var endByte = startByte + numBytes;

            var firstChar = str.charCodeAt(j++);
            if (firstChar !== 0) {
                buf.writeUInt8(firstChar & 0xFF, 0);
                startByte = 1;
            }
            for (var i = startByte; i < endByte; i += 2) {
                var chr = str.charCodeAt(j++);
                if (endByte - i === 1) {
                    buf.writeUInt8(chr >> 8, i);
                }
                if (endByte - i >= 2) {
                    buf.writeUInt16BE(chr, i);
                }
            }
            return numBytes;
        };

        BINSTR.byte2str = function (buff) {
            var len = buff.length;

            if (len === 0) {
                return '';
            }
            var chars = new Array((len >> 1) + 1);
            var j = 0;
            for (var i = 0; i < chars.length; i++) {
                if (i === 0) {
                    if (len % 2 === 1) {
                        chars[i] = String.fromCharCode((1 << 8) | buff.readUInt8(j++));
                    } else {
                        chars[i] = String.fromCharCode(0);
                    }
                } else {
                    chars[i] = String.fromCharCode((buff.readUInt8(j++) << 8) | buff.readUInt8(j++));
                }
            }
            return chars.join('');
        };

        BINSTR.byteLength = function (str) {
            if (str.length === 0) {
                return 0;
            }
            var firstChar = str.charCodeAt(0);
            var bytelen = (str.length - 1) << 1;
            if (firstChar !== 0) {
                bytelen++;
            }
            return bytelen;
        };
        return BINSTR;
    })();
    exports.BINSTR = BINSTR;

    var BINSTRIE = (function () {
        function BINSTRIE() {
        }
        BINSTRIE.str2byte = function (str, buf) {
            var length = str.length > buf.length ? buf.length : str.length;
            for (var i = 0; i < length; i++) {
                buf.writeUInt8(str.charCodeAt(i) - 0x20, i);
            }
            return length;
        };

        BINSTRIE.byte2str = function (buff) {
            var chars = new Array(buff.length);
            for (var i = 0; i < buff.length; i++) {
                chars[i] = String.fromCharCode(buff.readUInt8(i) + 0x20);
            }
            return chars.join('');
        };

        BINSTRIE.byteLength = function (str) {
            return str.length;
        };
        return BINSTRIE;
    })();
    exports.BINSTRIE = BINSTRIE;
});
//# sourceMappingURL=string_util.js.map
;